import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=235d9207&scoped=true&"
import script from "./issue.vue?vue&type=script&lang=js&"
export * from "./issue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235d9207",
  null
  
)

export default component.exports